import { create } from 'zustand'
import { AlertVariantName } from '../../components/common/Alert/Alert'
import { v4 as uuidv4 } from 'uuid'

export type ToastAlert = {
    id: string
    variant: AlertVariantName
    title: string
    description?: string
}

export type ToastStore = {
    alerts: ToastAlert[]
    addAlert: (alert: Omit<ToastAlert, 'id'>) => string
    removeAlert: (id: string) => void
    timers: Record<string, ReturnType<typeof setTimeout>>
}

const useToastStore = create<ToastStore>((set, get) => ({
    alerts: [],
    timers: {},

    addAlert: (alert) => {
        const id = uuidv4()

        set((state) => ({
            alerts: [...state.alerts, { ...alert, id }],
        }))

        const timer = setTimeout(() => {
            get().removeAlert(id)
        }, 3000)

        set((state) => ({
            timers: {
                ...state.timers,
                [id]: timer,
            },
        }))

        return id
    },

    removeAlert: (id) => {
        set((state) => ({
            alerts: state.alerts.filter((alert) => alert.id !== id),
        }))

        const timer = get().timers[id]

        clearTimeout(timer)

        set((state) => {
            const { [id]: _, ...updatedTimers } = state.timers
            return { timers: updatedTimers }
        })
    },
}))

export default useToastStore
